import { LocaleAuth } from '../en/auth'

const auth: LocaleAuth = {
  heading: 'Para el Deporte, Por el Deporte.',
  signIn: 'Iniciar sesión',
  forgotPass: '¿Olvidaste tu contraseña?',
  claimQuestion: '¿Solo en un torneo?',
  claimAccount: 'Reclama tu cuenta',
  claimAccountDesc:
    '¿Ya has jugado en un torneo o una liga? Es posible que ya tengas un perfil de jugador y una clasificación DUPR.',
  noAccount: '¿No tienes una cuenta DUPR?',
  signUp: 'Registrarse',
  createAccount: 'Crear cuenta',
  createPassword: 'Crear contraseña',
  passInstructLength: 'Debe tener al menos 6 caracteres de longitud',
  passInstructStructure: 'Debe contener uno o más números',
  forgotPassDesc:
    'Ingresa tu correo electrónico registrado para recibir instrucciones sobre cómo restablecer tu contraseña.',
  checkYourEmail: '¡Revisa tu correo electrónico!',
  resetCodeSentGeneric: 'Si existe una cuenta para esa dirección, hemos enviado un código de 4 dígitos.',
  verifyEmailDesc:
    'Acabas de recibir un código para restablecer tu contraseña por correo electrónico. Ingresa el código de 4 dígitos para continuar.',
  verifyYourNumber: 'Verifica tu número',
  verifyPhoneNumberDesc: 'Se envió un código de 4 dígitos a tu número de teléfono; ingrésalo aquí para verificarlo.',
  claimAccountHelpText: 'Escribe tu nombre en la barra de búsqueda para comenzar a buscar tus resultados.',
  notSeeYourself: '¿No te ves aquí?',
  lastMatch: 'Último Partido',
  noMatchResult: 'Sin resultado de partido.',
  accAlreadyTaken: 'Esta cuenta ya está tomada.',
  accAlreadyTakenModal:
    'Si crees que eres tú y alguien más ha reclamado tu cuenta, por favor, ponte en contacto con nuestro equipo de soporte.',
  iAgreeToThe: 'Acepto los',
  termsOfService: 'Términos de Servicio',
  privacyPolicy: 'Política de Privacidad',
  acceptTerms: 'Por favor, acepta los Términos de Servicio para continuar',
  cookiePolicy: 'Política de Cookies',
}

export default auth
